<div #toastOutlet></div>

<div class="flex flex-col">
  <!-- Role Selection -->
  <div class="justify-start">
    <p class="font-semibold text-xl" data-testid="role-selector">
      Pick a role for candidate
    </p>
    <div class="my-5 max-w-72">
      <app-select
        data-testid="select-role-button"
        [id]="'role-selector'"
        [name]="'role-selector'"
        [items]="selectItems()"
        [(selectedItem)]="selectedRole" />
    </div>
  </div>

  <form
    (submit)="handleSubmit($event)"
    (submit)="$event.preventDefault()"
    class="flex min-w-0 min-h-0">
    <div class="flex flex-col lg:flex-row gap-4 min-h-0 w-full flex-1">
      <!-- Test Set Selection -->
      <div class="flex-1 min-w-0 card p-6">
        <div class="flex lg:flex-row flex-col mb-4 bg-base-100 items-baseline">
          <h2
            class="lg:text-4xl text-2xl font-bold"
            data-testid="test-set-selection-header">
            {{ selectedRole().label }}&nbsp;
          </h2>
          <h3 class="lg:text-2xl text-lg font-semibold text-gray-500">
            (Please choose test set)
          </h3>
        </div>
        <div class="flex-1">
          @if (loading()) {
          <div class="flex items-center justify-center h-full">
            <span class="loading loading-dots loading-lg"></span>
          </div>
          } @else if (testSetItems().length === 0) {
          <div>No test sets found.</div>
          } @else {
          <div class="flex flex-col space-y-4">
            @for(item of testSetItems(); track item.testSetId) {
            <app-item
              [id]="item.testSetId"
              [name]="'invitationsTestSet'"
              [title]="item.title"
              [description]="item.description"
              [difficulty]="item.difficulty"
              [duration]="item.duration"
              [selector]="'radio'"
              [selectedValue]="selectedTestSetId()!"
              (selectItem)="selectedTestSetId.set($event)" />
            }
          </div>
          }
        </div>
      </div>

      <!-- send Email Form -->
      <div class="flex-shrink-0 lg:w-146 flex flex-col gap-4 min-h-0">
        <div
          class="sticky top-30 p-6 card overflow-hidden flex flex-col flex-shrink-0">
          <div class="flex flex-1 flex-col items-start gap-6">
            <!-- Email -->
            <div class="flex flex-col w-full">
              <p class="text-xl lg:text-2xl font-semibold text-black">
                Email <sup class="text-red-500">*</sup>
              </p>
              <div class="mt-3">
                <app-email-tag-input
                  [id]="'email-tag-input'"
                  [isRequired]="true"
                  [(tags)]="emailTagInputValue"
                  [(errorMessage)]="emailTagInputError" />
              </div>
            </div>

            <!-- Available from -->
            <div class="flex flex-col w-full">
              <p class="text-xl lg:text-2xl font-semibold text-black">
                Available from
                <span class="text-lg font-semibold text-gray-500">
                  (Up to 72 hours)
                </span>
                <sup class="text-red-500">*</sup>
              </p>
              <div class="mt-3">
                <app-date-time-input
                  data-testid="available-from-input"
                  [id]="'available-from-input'"
                  type="datetime-local"
                  [name]="'availableFrom'"
                  [isRequired]="true"
                  [(value)]="availableFromValue"
                  [(errorMessage)]="availableFromError" />
              </div>
            </div>

            <!-- Available until -->
            <div class="flex flex-col w-full">
              <div class="flex flex-row items-baseline">
                <p class="text-xl lg:text-2xl font-semibold text-black">
                  Available until
                  <span class="text-lg font-semibold text-gray-500">
                    (Before midnight 23:59)
                  </span>
                  <sup class="text-red-500">*</sup>
                </p>
              </div>
              <div class="mt-3">
                <app-date-time-input
                  data-testid="available-until-input"
                  [id]="'available-until-input'"
                  type="date"
                  [name]="'availableUntil'"
                  [isRequired]="true"
                  [(value)]="availableUntilValue"
                  [(errorMessage)]="availableUntilError" />
              </div>
            </div>

            <!-- Submit Button -->
            <div
              class="flex flex-row sticky bottom-0 bg-base-100 pt-2 items-baseline w-full justify-end">
              <app-button
                data-testid="submit-button"
                [id]="'submit-button'"
                color="primary"
                size="medium"
                label="Send"
                type="submit"
                [disabled]="!canSubmit() || isSubmitting()" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
